import Image from '@/components/general/Image/Image'
import Link from 'next/link'
import styles from './box-product.module.scss'
import { format } from 'date-fns'

export default function BoxProduct(props) {
  const {
    title, subTitle, image, category, price, url = '', updatedAt = '', ...otherProps
  } = props
  return (
    <div className={styles.product} {...otherProps}>
      <Link href={url} target="_blank" rel="noopener noreferrer">
        <a href={url} target="_blank" rel="noopener noreferrer" className={styles.imgPlaceholder}>
          <Image width={800} height={670} absolute cover layout="responsive" src={image} />
        </a>
      </Link>
      <div className={styles.productDetail}>
        <Link href={url} target="_blank" rel="noopener noreferrer">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <h3 className={styles.title}>{title}</h3>
          </a>
        </Link>
        <h4 className={styles.subTitle}>{subTitle}</h4>
        <span className={styles.brand}>
          {category}
        </span>
        {updatedAt &&
          <span className={styles.date}>
            {format(new Date(updatedAt), 'dd/MM/yyyy')}
          </span>
        }
        <span className={styles.price}>
          {price}
        </span>
      </div>
    </div>
  )
}

export function ProductSkeleton() {
  return (
    <>
      <div className={styles.productSkeleton} />
      <div className={styles.productSkeleton} />
      <div className={styles.productSkeleton} />
      <div className={styles.productSkeleton} />
    </>
  )
}
